import React, { Component, createElement } from 'react';
// import { callGET } from '../../../Utils/ApiUtil';
import {
    extractStylesAsObjects,
    getFieldsPropsElement,
    getFieldsPropsSection,
    getOutputFieldsElement,
    extractFieldValue
} from '../../../Components/MarkupConversion/MarkupFunctions';
import { isSet } from '../../../Utils/CommonFunctions';
import htmlToJson from 'html-to-json';
import $ from 'jquery';
import { parse } from 'himalaya';
import MarkupConversion from '../../../Components/MarkupConversion';
import Inputs from '../../../Components/Inputs/Inputs';
// import update from 'react-addons-update';

class CustomLoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            domainName: "",
            loginPageRender: null,
            loginForm: {
                userName: "",
                userPassword: ""
            },
            outputResponse:{},
        }
    }

    componentDidMount = () => {
        // console.log("componentDidMount Customlogin", "this.props.match.path", this.props.match.path);
        if(this.props.htmlLoginPage){
            let convertedHtml = parse(this.props.htmlLoginPage.replace("[\\n\\r\\t]+", ""));
            console.log('convertedHtml',convertedHtml);
            this.setState({
                loginPageRender:convertedHtml
            })
            this.processDirectTrack();
        }

        // this.getDomainLoginPage(window.location.hostname, (this.props.match.path === "/signup") ? true : false);
    }

    processDirectTrack() {
        const { trackingNumber, page } = this.props.match.params;
        let searchValue = trackingNumber;
        let SearchBy = page || (searchValue ? 'number' : "");
        let payload = {};
        if (!searchValue) {
            return;
        }
        if (SearchBy &&  SearchBy.toLowerCase() == "number") {
            payload.SearchBy = "TRACKING_NUMBER";
            payload.tracking_numbers = searchValue;
        } else if (SearchBy && SearchBy.toLowerCase() == "order") {
            payload.SearchBy = "ORDER_ID";
            payload.order_ids = searchValue;
        }
        this.props.updatePayloadHandler(payload);
        setTimeout(()=>{
            this.props.submitTrackingHandler();
        },500);
      }
    
    componentDidUpdate = (prevProps) => {
        // console.log('ComponentDidUpdate.... Customlgogin');
        // console.log("new html",this.props.htmlLoginPage,"old html",prevProps.htmlLoginPage);
        
        // if(this.state.loginPageRender!==this.state.log)
    }
    // getDomainLoginPage = (domainName) => {
    //     this.props.Loader(true);
    //     console.log("getDomainLoginPAge", domainName);
    //     callGET("domain/" + domainName + "/get-login-page/")
    //         .then(res => {
    //             console.log("GetDomainLoginPageRespose", res);
    //             if (res.status === 200) {
    //                 const resData = res.data;
    //                 if (resData.code === 200 && resData.message !== "" && resData.data.custom_login_acive) {
    //                     let convertedHtml = parse(resData.message.replace("[\\n\\r\\t]+", ""));
    //                     console.log("CONVERTED TOJSON ==> ",convertedHtml)
    //                     this.setState({
    //                         htmlLoginPage: resData.message,
    //                         loginPageRender: convertedHtml
    //                     })
    //                 }else {
    //                     console.log("GET LOGIN PAGE RESPONSE====????", resData.message);
    //                     this.props.failMessage(resData.message);
    //                     this.props.switchCustomLogin(false);
    //                 }
    //                 this.props.Loader(false);
    //             }
    //         }, (error) => {
    //             console.log("Error", error);
    //             this.props.switchCustomLogin(false);
    //             this.props.Loader(false);
    //         })
    // }

    convertMarkupToJSON = (wthis) => {
        let dynamicContent = '<Root>' + this.props.htmlLoginPage + '</Root>';
        var promise = htmlToJson.parse(dynamicContent, {
            'HTML': function ($doc) {
                return $doc;
            }
        }, function (err, result) {
            // result.HTML[0].children.map((item)=>{
            //     console.log(item.children);
            //     let htmlElement = item.children;
            //     htmlElement.push({...htmlElement});
            // });
        });
        promise.done(function (result) {
            console.log("result", result)
            result.HTML[0].children.map((item) => {
                console.log("child", item.children);
                wthis.setState({ loginPageRender: item.children });
            })
        });
    }
    convertHtmlAndCreateElement = (htmlElement, paramObj) => {
        const { loopData, dynamicVar, dataTable } = paramObj;
        let notAllowingTagReplacement = { 'html': 'manualhtml', 'meta': 'manualheta', 'title': 'manualtitle', "!doctypehtml": "", 'script1': 'manualscript' };
        let notAllowingTag = ['html', 'meta', 'title', 'script', "!doctypehtml"];
        let allowedTags = ['html', 'meta', 'title', 'script', 'style', 'div', 'span', 'i', 'h', 'p', 'form', "link", "input", "a", "body", "head"]
        console.log("paramObj", "loopData,dynamicVar,dataTable", loopData, dynamicVar, dataTable);
        return htmlElement.map((item, itemIndex) => {
            console.log("htmlElement", item, itemIndex);
            const { children, type } = item;
            const attribs = (item.hasOwnProperty('attribs') === true) ? item.attribs : {};
            let attributes = {
                ...attribs,
                id: isSet(attribs.id, itemIndex)
            }
            console.log("children", children, "type", type);
            let tagName = (item.hasOwnProperty('name') === true) ? item.name : '';
            if (notAllowingTag.indexOf(tagName) !== -1) {
                tagName = notAllowingTagReplacement[tagName];
            }
            if (allowedTags.indexOf(tagName) === -1) {
                console.log("nowAllowedTag", tagName);
                if (tagName.includes("div")) {
                    tagName = "div"
                } else {

                }

            }
            if ($(window).width() < 768) {
                $('#splitView_sidebar').addClass('active');
            } else {
                $('#splitView_sidebar').removeClass('active');
            }
            const defParams = { tagName: tagName, loopData: loopData, defProps: this.props, dataTable: dataTable, dynamicVar: dynamicVar, children: children, childActionButtons: [] };
            console.log("defParams", defParams)
            if (attributes.hasOwnProperty('style') && typeof attributes.style === 'string') {
                attributes.style = extractStylesAsObjects(attributes.style);
            }
            if (type === "tag" || type === "style") {
                if (children !== undefined && children.length === 0) {
                    return React.createElement(tagName, { ...attributes });
                } else if (children !== undefined) {
                    return React.createElement(tagName, { ...attributes }, this.convertHtmlAndCreateElement(children, { loopData, dataTable, dynamicVar }));
                }
            } else if (type === "text") {
                const itemData = item.data;
                const startingIndex = itemData.indexOf('${');
                const endingIndex = itemData.indexOf('}');
                let displayContent = itemData;
                if (itemData.indexOf('${') !== -1 && itemData.indexOf('}') !== -1) {
                    let variableValue = itemData.substring((startingIndex), endingIndex);
                    variableValue = variableValue.replace(/{/gi, '');
                    variableValue = variableValue.replace('$', '');
                    variableValue = variableValue.replace(/}/gi, '');
                    const replacingValue = getOutputFieldsElement({ ...attributes, value: variableValue.trim() }, defParams);
                    displayContent = itemData.replace('${' + variableValue + '}', replacingValue);
                }
                return displayContent;
            }

        })
    }
    // newConvertAndCreateElement = (htmlJson, otherObj) => {
    //     const { loopData, dynamicVar, dataTable } = otherObj;
    //     console.log("newConvertAndCreateElement", htmlJson);
    //     let notAllowingTagReplacement = { 'html': 'manualhtml', 'meta': 'manualheta', 'title': 'manualtitle', 'script1': 'manualscript' };
    //     let notAllowingTag = ['html', 'meta', 'title', 'script',];
    //     let nowAllowedAttributes = [""];
    //     if (htmlJson !== null && Array.isArray(htmlJson)) {
    //         return htmlJson.map((item, itemIndex) => {
    //             console.log("jsonItem", item, itemIndex);
    //             const { type } = item;
    //             let { children } = item;
    //             let tagName = (item.hasOwnProperty("tagName") === true) ? item.tagName : "";
    //             // if (notAllowingTag.indexOf(tagName) !== -1) {
    //             //     tagName = notAllowingTagReplacement[tagName];
    //             // }
    //             const defParams = { tagName: tagName, loopData: loopData, defProps: this.props, dataTable: dataTable, dynamicVar: dynamicVar, children: children, childActionButtons: [] };
    //             const attribs = (item.hasOwnProperty('attributes') === true) ? item.attributes : [];

    //             let attributes = {};
    //             if (attribs.length > 0) {
    //                 isSet(attribs, []).map((attribs) => {
    //                     if (nowAllowedAttributes.indexOf(attribs.key) === -1) {
    //                         if (attribs.key === "style") {
    //                             try {
    //                                 var styleObject = JSON.parse(attribs.value);
    //                                 attributes = { ...attributes, [attribs.key]: styleObject }
    //                             } catch (e) {
    //                                 console.log(e)
    //                             }
    //                         } else {
    //                             attributes = { ...attributes, [attribs.key]: attribs.value }
    //                         }
    //                     }
    //                 })
    //             }
    //             attributes = {
    //                 ...attributes,
    //                 id: isSet(attributes.id, itemIndex + "_" + tagName)
    //             }
    //             if (attributes.scm !== undefined && attributes.scm !== "") {
    //                 console.log("scm==>", attributes.scm, "children", children);
    //                 let updatedItem = this.setEventsAndValue(attributes, attributes.scm, children);
    //                 children = updatedItem.children;
    //                 attributes = updatedItem.attributes;
    //                 console.log("scm==XXX", attributes.scm, "children", children);
    //             }
               
    //             console.log("after functional assignment", attributes);
    //             if (type === "element") {
    //                 if (children !== undefined && children.length > 0) {
    //                     return createElement(tagName, attributes, this.newConvertAndCreateElement(children, { loopData: [], dynamicVar: {} }))
    //                 } else {
    //                     return createElement(tagName, attributes, null)
    //                 }

    //             } else if (type === "text") {
    //                 let itemData = item.content;
    //                 let displayContent = itemData;
    //                 console.log("textType", item);
    //                 const startingIndex = itemData.indexOf('${');
    //                 const endingIndex = itemData.indexOf('}');
    //                 if (itemData.indexOf('const switchers') !== -1){
    //                     try{
    //                         const parser = new DOMParser();
    //                         const doc = parser.parseFromString(itemData, 'text/html');
    //                         displayContent = eval(doc.documentElement.textContent);
    //                     }catch(e){
    //                         console.log('displayContent',displayContent);
    //                     }
                        
    //                 }
    //                 if (itemData.indexOf('${') !== -1 && itemData.indexOf('}') !== -1) {
    //                     let variableValue = itemData.substring((startingIndex), endingIndex);
    //                     variableValue = variableValue.replace(/{/gi, '');
    //                     variableValue = variableValue.replace('$', '');
    //                     variableValue = variableValue.replace(/}/gi, '');
    //                     const replacingValue = getOutputFieldsElement({ ...attributes, value: variableValue.trim() }, defParams);
    //                     displayContent = itemData.replace('${' + variableValue + '}', replacingValue);
    //                 }
    //                 return displayContent;
    //             } else {
    //                 console.log("unpredicted Type====>", type, item, itemIndex);
    //             }

    //         })
    //     }
    // }

    setEventsAndValue = (attr, key, children) => {
        console.log("setEventsAndValue", key, attr, children);
        let updatedItem = {
            attributes: { ...attr },
            children: [...children]
        };
        let updatedAttributes = { ...updatedItem.attributes };
        let updatedChildren = [...updatedItem.children];
        let loginFunctions = {
            'handleClick': this.handleClick,
            "onChangeHandler": this.props.loginOnChangeHandler,
            "submitLoginHandler": this.props.submitLoginHandler
        }
        const { loginFormFields, loginError } = this.props;
        console.log("loginFormFields", loginFormFields, "loginError", loginError)
        if (key !== undefined && key !== "") {
            if (key === "#LOGINEMAILFIELD") {
                // SCM(#LOGINEMAILFIELD)
                updatedAttributes = {
                    ...updatedAttributes,
                    onChange: loginFunctions.onChangeHandler,
                    name: "email",
                    scm: "",
                    value: loginFormFields.email.value
                }

            } else if (key === "#LOGINPASSWORDFIELD") {
                updatedAttributes = {
                    ...updatedAttributes,
                    onChange: loginFunctions.onChangeHandler,
                    name: "password",
                    scm: "",
                    value: loginFormFields.password.value
                }
            } else if (key === "#LOGINSUBMITBUTTON") {
                console.log("login Button", attr, key, children)
                updatedAttributes = {
                    ...updatedAttributes,
                    onClick: loginFunctions.submitLoginHandler,
                    scm: "",
                    type: "button"
                }
            } else if (key === "#LOGINERRORMESSAGE") {
                console.log('children', children);
                let errorMessage = (loginError !== null && Array.isArray(loginError)) ? loginError.join(",") : (loginError !== null) ? loginError : "";


                updatedChildren.push({
                    type: "text",
                    content: errorMessage
                })
                console.log("updatedChildren", updatedChildren);
                updatedAttributes = {
                    ...updatedAttributes,
                    scm: "",
                }
            }
        }
        updatedItem = {
            attributes: { ...updatedAttributes },
            children: [...updatedChildren]
        }
        return updatedItem;

    }

    convertAndCreateElement = (htmlElement, paramObj) => {
        const { childActionButtons } = this.state;
        const { loopData, dynamicVar, dataTable } = paramObj;
        let notAllowingTagReplacement = { 'html': 'manualhtml', 'meta': 'manualheta', 'title': 'manualtitle', 'script': 'manualscript' };
        let notAllowingTag = ['html', 'meta', 'title', 'script'];
        return htmlElement.map((item, itemIndex) => {
            const { children, type } = item;

            const attribs = (item.hasOwnProperty('attribs') === true) ? item.attribs : {};
            let attributes = {
                ...attribs,
                id: isSet(attribs.id, itemIndex)
            }
            let tagName = (item.hasOwnProperty('name') === true) ? item.name : '';
            let attribsName = (attributes.hasOwnProperty('name') === true) ? attributes.name : '';
            if (attributes.hasOwnProperty('style') && typeof attributes.style === 'string') {
                attributes.style = extractStylesAsObjects(attributes.style);
            }
            if (notAllowingTag.indexOf(tagName) !== -1) {
                tagName = notAllowingTagReplacement[tagName];
            }
            if ($(window).width() < 768) {
                $('#splitView_sidebar').addClass('active');
            } else {
                $('#splitView_sidebar').removeClass('active');
            }
            const defParams = { tagName: tagName, loopData: loopData, defProps: this.props, dataTable: dataTable, dynamicVar: dynamicVar, children: children, childActionButtons: childActionButtons };
            if (type === 'tag' || type === 'style') {
                switch (tagName) {
                    case "scm:inputtext":
                        return getFieldsPropsElement(attributes, { type: 'FIELD', ...defParams });
                    case "scm:inputsection":
                        return getFieldsPropsSection(attributes, { type: 'SECTION', ...defParams });
                    // case "scm:inputsubform":
                    //     return getFieldsPropsElement(attributes,{type:'SECTION',defProps:this.props});
                    case "scm:outputtext":
                    case "scm:outputimage":
                        return getOutputFieldsElement(attributes, defParams);
                    // case "scm:decision":
                    // case "scm:if":
                    //     return this.getConditionalFieldsElement(attributes, defParams);
                    // case "scm:datatable":
                    //     return this.getDataTableDetails(attributes, defParams);
                    // case "scm:button":
                    //     return this.getActionButtonsElement(attributes, defParams);
                    default:
                        if (children.length === 0) {
                            return React.createElement(tagName, { ...attributes });
                        } else {
                            return React.createElement(tagName, { ...attributes }, this.convertAndCreateElement(children, { loopData, dataTable, dynamicVar, childActionButtons }));
                        }
                }
            } else if (type === 'text') {
                const itemData = item.data;
                const startingIndex = itemData.indexOf('${');
                const endingIndex = itemData.indexOf('}');
                let displayContent = itemData;
                if (itemData.indexOf('${') !== -1 && itemData.indexOf('}') !== -1) {
                    let variableValue = itemData.substring((startingIndex), endingIndex);
                    variableValue = variableValue.replace(/{/gi, '');
                    variableValue = variableValue.replace('$', '');
                    variableValue = variableValue.replace(/}/gi, '');
                    const replacingValue = getOutputFieldsElement({ ...attributes, value: variableValue.trim() }, defParams);
                    displayContent = itemData.replace('${' + variableValue + '}', replacingValue);
                }
                return displayContent;
            }
        })

    }

    onChangeHandler = (e) => {
        const { value, name } = e.target
        console.log("onChangeHandler", "name", name, "value", value);
        let updatedLoginForm = { ...this.state.loginForm }
        if (name != "") {
            // updatedLoginForm.9name=value;
            this.setState({
                loginForm: { ...updatedLoginForm, [name]: value }
            })
        }
    }
    handleClick = () => {
        console.log("Button Clicked");
    }

    handleKeyDown = (event) => {   
        const KeyCodes = {
            // comma: 188,
            enter: 13,
        };
        const delimiters = [KeyCodes.comma, KeyCodes.enter];
        if (delimiters.indexOf(event.keyCode) !== -1 ) {
            this.props.submitLoginHandler();
        }
    }
    handleKeyDownTracker =  (event) => {   
        const KeyCodes = {
            // comma: 188,
            enter: 13,
        };
        const delimiters = [KeyCodes.comma, KeyCodes.enter];
        if (delimiters.indexOf(event.keyCode) !== -1 ) {
            this.props.submitTrackingHandler();
        }
    }


    render() {
        // const { htmlLoginPag, loginPageRender } = this.state;
        // let loginPageRenderf = null;
        // console.log("LoginPageRender", loginPageRender);
        // let FunctionsList = {
        //     'handleClick': this.handleClick,
        //     "onChangeHandler": this.props.loginOnChangeHandler,
        //     "submitLoginHandler": this.props.submitLoginHandler

        // };
        // if (loginPageRender != null) {
        //     loginPageRenderf = this.newConvertAndCreateElement(loginPageRender, { loopData: [], dynamicVar: {} });
        //     setTimeout(() => {
        //         this.props.Loader(false)
        //     }, 300);
        // } else {
        //     this.props.Loader(true);
        // }
        // let formFields = [];

        
        const {loginFormFields,formsPayload,formsValidations,outputResponse,requestPayload} = this.props;
        const {customFormFields} = requestPayload;
        // loginFormFields?
        const formFields = isSet(customFormFields,[]).map((itm)=>{
            let attr = {};
            if(isSet(itm.isLoginField,false)===true){
                attr = {
                    attributes:{
                        onKeyDown:this.handleKeyDown
                    },
                    error:isSet(loginFormFields[itm.name].error,''),
                    value:isSet(loginFormFields[itm.name].value,''),
                    changeHandler:(val,e)=>this.props.loginOnChangeHandler(e),
                }
            }else{
                attr = {
                    attributes:{
                        onKeyDown:this.handleKeyDownTracker
                    },
                    error:isSet(formsValidations[itm.name],''),
                    value:isSet(formsPayload[itm.name],''),
                    changeHandler:(val,e)=>this.props.onChangeHandler(itm.name,val),  
                }
            }
            return{
                ...itm,
                ...attr
            }
        });
        //  [{
        //     label:'Email',
        //     className: 'form-control',
        //     name:'email',
        //     type:'TextInput',
        //     error:isSet(loginFormFields['email'].error,''),
        //     value:isSet(loginFormFields['email'].value,''),
        //     isEvent:true,
        //     changeHandler:(val,e)=>this.props.loginOnChangeHandler(e),  
        // },{
        //     label:'Password',
        //     className: 'form-control',
        //     type:'Password',
        //     name:'password',
        //     isEvent:true,
        //     error:isSet(loginFormFields['password'].error,''),
        //     value:isSet(loginFormFields['password'].value,''),
        //     changeHandler:(val,e)=>this.props.loginOnChangeHandler(e),  
        // },{
        //     label:'Track by',
        //     className: 'form-control mandatory',
        //     type:'PickList',
        //     isDefault:true,
        //     options:[{
        //         id:'',
        //         value:'-Select-'
        //     },{
        //         id:'ORDER_ID',
        //         value:'Order ID',
        //     },{
        //         id:'TRACKING_NUMBER',
        //         value:'Tracking Number'
        //     },{
        //         id:'REFERENCE',
        //         value:'Reference'
        //     }],
        //     name:'SearchBy',
        //     isEvent:true,
        //     error:isSet(formsValidations['SearchBy'],''),
        //     value:isSet(formsPayload['SearchBy'],''),
        //     changeHandler:(val,e)=>this.props.onChangeHandler('SearchBy',val),  
        // },
        // {
        //     label:'Customer Number',
        //     className: 'form-control mandatory',
        //     type:'TextInput',
        //     required:true,
        //     name:'account_id',
        //     isEvent:true,
        //     error:isSet(formsValidations['account_id'],''),
        //     value:isSet(formsPayload['account_id'],''),
        //     changeHandler:(val,e)=>this.props.onChangeHandler('account_id',val),  
        // },{
        //     label:'Order ID',
        //     className: 'form-control mandatory',
        //     type:'TextInput',
        //     name:'order_ids',
        //     isEvent:true,
        //     error:isSet(formsValidations['order_ids'],''),
        //     value:isSet(formsPayload['order_ids'],''),
        //     changeHandler:(val,e)=>this.props.onChangeHandler('order_ids',val),  
        // },
        // {
        //     label:'Tracking Number',
        //     className: 'form-control mandatory',
        //     type:'TextInput',
        //     name:'tracking_numbers',
        //     isEvent:true,
        //     error:isSet(formsValidations['tracking_numbers'],''),
        //     value:isSet(formsPayload['tracking_numbers'],''),
        //     changeHandler:(val,e)=>this.props.onChangeHandler('tracking_numbers',val),  
        // },
        // {
        //     label:'Track by Number',
        //     className: 'form-control mandatory',
        //     type:'TextInput',
        //     name:'reference_codes',
        //     isEvent:true,
        //     error:isSet(formsValidations['reference_codes'],''),
        //     value:isSet(formsPayload['reference_codes'],''),
        //     changeHandler:(val,e)=>this.props.onChangeHandler('reference_codes',val),  
        // }];

        const actionButtons = [{
            name:'Login',
            clickHandler:this.props.submitLoginHandler
        },{
            name:'Track',
            clickHandler:this.props.submitTrackingHandler
        },{
            name:'Reset',
            clickHandler:this.props.clearTrackingHandler
        }];
        // console.log('outputResponse',requestPayload,JSON.stringify(outputResponse.shipment_details));
        return(
            <MarkupConversion 
                renderProps={[]}
                htmlContent={this.props.htmlLoginPage}
                formFields={formFields}
                formsPayload={formsPayload}
                actionButtons={actionButtons}
                rateWithShipments={outputResponse}
                layoutForms={true} />
        )

    }


}
export default CustomLoginPage;